// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".videoBox[data-v-47088f3a]{width:100%;padding-top:16px}.bigVideo[data-v-47088f3a]{height:544px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
